import _ from 'lodash';
import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Row } from 'reactstrap';
import { compose } from 'redux';
import { HomeListItem, HomeListItemType } from '../../model/HomeListItem';
import { IRootState } from '../../reducer';
import './home.scss';

export interface AnnotationsListProps {
    specialtiesList?: HomeListItem[];
    leafletList?: HomeListItem[];
    semiologyList?: HomeListItem[];
    calculatorList?: HomeListItem[];
    scoreList?: HomeListItem[];
    laboratoryList?: HomeListItem[];
    procedureList?: HomeListItem[];
    criteriaList?: HomeListItem[];
    doseList?: HomeListItem[];

    onItemClick: (item: HomeListItem) => void;
    t: any;

    history: any;
}
export const AnnotationsList = (props: AnnotationsListProps) => {
    const [filters, setFilter] = useState<HomeListItemType[]>([]);

    const onFilter = (type: HomeListItemType): void => {
        if (filters.includes(type)) {
            setFilter(filters.filter(it => it !== type));
        } else {
            setFilter(filters.concat(type));
        }
    };

    const onGoToSpeciaties = (): void => {
        props.history.push('/specialty');
    };
    const onGoToLeaflets = (): void => {
        props.history.push('/smart-bulas');
    };

    const listsAreEmpty: boolean =
        props.specialtiesList?.length === 0 &&
        props.leafletList?.length === 0 &&
        props.semiologyList?.length === 0 &&
        props.criteriaList?.length === 0 &&
        props.laboratoryList?.length === 0;
    const titleIcon: any = listsAreEmpty ? require('../../images/empty-pencil.svg') : require('../../images/orange-pencil.svg');
    const lineColor: string = listsAreEmpty ? 'title-line--gray' : 'title-line--orange';
    const diseaseIconClass: string = filters.includes(HomeListItemType.DISEASE)
        ? 'filters__disease-img filters__disease-img--orange'
        : 'filters__disease-img';
    const leafletIconClass: string = filters.includes(HomeListItemType.MEDICINE_LEAFLET)
        ? 'filters__leaflet-img filters__leaflet-img--orange'
        : 'filters__leaflet-img';
    return (
        <div className="home-list" style={{ width: '100%' }}>
            <div className="container">
                <Row style={{ marginTop: 30, marginBottom: 26, justifyContent: 'space-between' }}>
                    <div>
                        <Row className="align-items-center">
                            <img src={titleIcon} className="icon" alt={props.t('home.favorites')} />
                            <span className="title">{props.t('home.annotations')}</span>
                        </Row>
                        <div className={`title-line ${lineColor}`} />
                    </div>
                    <div className="filters">
                        <div className={diseaseIconClass} onClick={() => onFilter(HomeListItemType.DISEASE)} />
                        <div className={leafletIconClass} onClick={() => onFilter(HomeListItemType.MEDICINE_LEAFLET)} />
                    </div>
                </Row>
                {listsAreEmpty ? (
                    <div className="empty-list" style={{ paddingBottom: 60 }}>
                        <div className="empty-list__lock-img" />
                        <span style={{ width: 269, textAlign: 'center' }}>
                            <span className="empty-list__text">{props.t('home.emptyAnnotations1')}</span>
                            <span className="empty-list__text empty-list__text--highlighted" onClick={onGoToSpeciaties}>
                                {props.t('home.emptyAnnotations2')}
                            </span>
                            <span className="empty-list__text">{props.t('home.emptyAnnotations3')}</span>
                            <span className="empty-list__text empty-list__text--highlighted" onClick={onGoToLeaflets}>
                                {props.t('home.emptyAnnotations4')}
                            </span>
                            <span className="empty-list__text">{props.t('home.emptyAnnotations5')}</span>
                        </span>
                    </div>
                ) : (
                    <div className="section-list">
                        <AnnotationsListSection
                            key={1}
                            list={props.specialtiesList}
                            sectionTitle={props.t('home.specialties')}
                            iconClassName={'bacteria-img'}
                            onItemClick={props.onItemClick}
                            showList={filters == null || filters.length === 0 || filters.includes(HomeListItemType.DISEASE)}
                        />
                        <AnnotationsListSection
                            key={2}
                            list={props.leafletList}
                            sectionTitle={props.t('home.leaflets')}
                            iconClassName={'leaflet-img'}
                            onItemClick={props.onItemClick}
                            showList={filters == null || filters.length === 0 || filters.includes(HomeListItemType.MEDICINE_LEAFLET)}
                        />
                        <AnnotationsListSection
                            key={3}
                            list={props.semiologyList}
                            sectionTitle={props.t('home.semiology')}
                            iconClassName={'semiology-img'}
                            onItemClick={props.onItemClick}
                            showList={filters == null || filters.length === 0 || filters.includes(HomeListItemType.SEMIOLOGY)}
                        />
                        <AnnotationsListSection
                            key={4}
                            list={props.laboratoryList}
                            sectionTitle={props.t('home.laboratory')}
                            iconClassName={'laboratory-img'}
                            onItemClick={props.onItemClick}
                            showList={filters == null || filters.length === 0 || filters.includes(HomeListItemType.LABORATORY)}
                        />
                        <AnnotationsListSection
                            key={5}
                            list={props.procedureList}
                            sectionTitle={props.t('home.procedure')}
                            iconClassName={'procedure-img'}
                            onItemClick={props.onItemClick}
                            showList={filters == null || filters.length === 0 || filters.includes(HomeListItemType.ILLUSTRATED_PROCEDURE)}
                        />
                        <AnnotationsListSection
                            key={6}
                            list={props.doseList}
                            sectionTitle={props.t('home.pediatricDoses')}
                            iconClassName={'dose-img'}
                            onItemClick={props.onItemClick}
                            showList={filters == null || filters.length === 0 || filters.includes(HomeListItemType.PEDIATRIC_DOSE)}
                        />
                        <AnnotationsListSection
                            key={7}
                            list={props.calculatorList}
                            sectionTitle={props.t('home.medicalCalculator')}
                            iconClassName={'calculate-img'}
                            onItemClick={props.onItemClick}
                            showList={filters == null || filters.length === 0 || filters.includes(HomeListItemType.MEDICAL_CALCULATOR)}
                        />
                        <AnnotationsListSection
                            key={8}
                            list={props.scoreList}
                            sectionTitle={props.t('home.score')}
                            iconClassName={'calculate-img'}
                            onItemClick={props.onItemClick}
                            showList={filters == null || filters.length === 0 || filters.includes(HomeListItemType.SCORE)}
                        />
                        <AnnotationsListSection
                            key={9}
                            list={props.criteriaList}
                            sectionTitle={props.t('home.criteria')}
                            iconClassName={'criteria-icon'}
                            onItemClick={props.onItemClick}
                            showList={filters == null || filters.length === 0 || filters.includes(HomeListItemType.CRITERIA)}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export const AnnotationsListSection = ({ sectionTitle, iconClassName, list, onItemClick, key, showList }) => {
    if (list == null || list.length === 0 || !showList) {
        return <div />;
    }
    return (
        <div key={key} className="section">
            <Row className="align-items-center">
                <div className={iconClassName} />
                <span className="section-title">{sectionTitle}</span>
            </Row>
            <ul className="item-list">
                {_.sortBy(list, 'name').map((item, index) => (
                    <AnnotationsListItem key={index} item={item} onItemClick={onItemClick} />
                ))}
            </ul>
        </div>
    );
};

export const AnnotationsListItem = ({
    item,
    onItemClick
}: {
    item: HomeListItem;
    onItemClick: (item: HomeListItem) => void;
}): JSX.Element => {
    return (
        <li className="item" onClick={() => onItemClick(item)}>
            <span className="item-text">{item.name}</span>
            {item.subtitle != null && <span className="item-subtitle">{item.subtitle}</span>}
            <div className="item-line" />
        </li>
    );
};

const mapStateToProps = ({}: IRootState) => ({});

const mapDispatchToProps = {};

export default compose(connect(mapStateToProps, mapDispatchToProps), withTranslation())(AnnotationsList) as React.ComponentType<any>;
